import type { StatusColor } from '../base/StatusToneEnum'
import { StatusToneEnum } from '../base/StatusToneEnum'
import { DocumentLinkStatusEnum } from './DocumentLinkStatusEnum'

export type DocumentLinkStatusDetailType = { description: string; value: DocumentLinkStatusEnum } & StatusColor

export const DocumentLinkStatus: Record<keyof typeof DocumentLinkStatusEnum, DocumentLinkStatusDetailType> = {
  Active: {
    value: DocumentLinkStatusEnum.Active,
    description: 'The link opens its document.',
    tone: StatusToneEnum.Active,
  },
  Expired: {
    value: DocumentLinkStatusEnum.Expired,
    description: 'The link passed its expiry and no longer opens its document.',
    tone: StatusToneEnum.Inactive,
  },
  Revoked: {
    value: DocumentLinkStatusEnum.Revoked,
    description: 'The link was revoked and no longer opens its document.',
    tone: StatusToneEnum.Cancelled,
  },
}
